import { useEffect, useState } from "react";
import { getRecentAgencyBatches, type AgencyBatchRecent } from "@/lib/agencyImport";

export function useAgencyBatches(selected: string, enabled = true) {
  const [batches, setBatches] = useState<AgencyBatchRecent[]>([]);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    getRecentAgencyBatches(selected, controller.signal).then(rows => { if (!controller.signal.aborted) { setBatches(Array.isArray(rows) ? rows : []); setError(""); } }).catch(() => { if (!controller.signal.aborted) setError("Popis uvoza paketa nije dostupan."); });
    return () => controller.abort();
  }, [selected, enabled]);
  return { batches, error };
}

export function AgencyBatchFilter({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  const { batches, error } = useAgencyBatches(value);
  return <label className="space-y-1 text-sm">Uvoz paketa<select className="min-h-11 w-full rounded-md border border-border bg-background px-2 text-sm" value={value} onChange={event => onChange(event.target.value)}>
    <option value="">Svi</option>
    {value && !batches.some(batch => batch.id === value) && <option value={value}>Odabrani uvoz paketa</option>}
    {batches.map(batch => <option key={batch.id} value={batch.id}>{batch.name} · {batch.uploaded_by_name}</option>)}
  </select>{error && <span role="alert" className="block">{error}</span>}</label>;
}
